export const URL_CONST = {
  dashboard: {
    home: '/dashboard',
    mitigation: '/dashboard/mitigation',
    mitigationList: '/dashboard/mitigation/list',
    awareness: '/dashboard/awareness',
    visualDetection: '/dashboard/visual',
    ato: '/dashboard/ato',
  },
  incidents: {
    self: '/irontraps',
    incidents: '/irontraps/incidents',
    unclassified: '/irontraps/incidents/unclassified',
    classified: '/irontraps/incidents/classified',
    attackdetails: '/irontraps/attackdetails',
    remediated: '/irontraps/history/remediations',
    reported: '/irontraps/history/reported-incidents',
    scanbackOverview: '/irontraps/scanback/overview',
    scanback: '/irontraps/incidents/scanback',
    challenged: '/irontraps/incidents/challenged',
    // ATO section: same incidents page, scoped to Account Takeover rows.
    atoIncidents: '/irontraps/ato-incidents',
    atoUnclassified: '/irontraps/ato-incidents/unclassified',
    atoClassified: '/irontraps/ato-incidents/classified',
    atoChallenged: '/irontraps/ato-incidents/challenged',
    serverscan: '/irontraps/serverscan',
    partners: '/partners/irontraps',
  },
  awarenessCenter: {
    self: '/awareness-center',
    campaigns: '/awareness-center/campaigns',
    scenarios: '/awareness-center/scenarios',
    callforaction: '/awareness-center/call-for-action',
    landingpage: '/awareness-center/landing-pages',
    report: '/awareness-center/report',
    // IC-52079: temporary simulation-results redesign URL until it replaces /html
    reportSimulationRedesign: '/awareness-center/report/:id/html/redesign',
    wizardCampaign: '/awareness-center/wizard-campaign',
    // Wizard campaign steps
    wizardCampaignPartnerCompany: '/company',
    wizardCampaignCampaignSetup: '/campaign-setup',
    wizardCampaignGenerateEmails: '/generate-emails',
    wizardCampaignCampaignMessage: '/message',
    wizardCampaignScenarios: '/scenarios',
    wizardCampaignLandingPage: '/landing-page',
    wizardCampaignTrainingModule: '/training-module',
    wizardCampaignReviewLaunch: '/review-launch',
  },
  mailboxes: {
    self: '/mailboxes',
    management: '/mailboxes/management',
    upload: '/mailboxes/upload',
    segments: '/mailboxes/segments',
    userReport: '/mailboxes/user-report',
    vipuser: '/mailboxes/management/vipuser',
  },
  dmarc: {
    self: '/dmarc',
  },
  encryptionPLG: {
    self: '/encryption',
  },
  deepfake: {
    self: '/deepfake',
    profiles: '/deepfake/profiles',
    meetings: '/deepfake/meetings',
    meetingDetails: '/deepfake/meetings/:meetingId',
  },
  psima: {
    self: '/psima',
    launched: '/psima/launched',
    settings: '/psima/settings',
  },
  settings: {
    self: '/settings',
    profile: '/settings/account/profile',
    general: '/settings/account/general',
    permissions: '/settings/account/users',
    languages: '/settings/account/languages',
    incidence: '/settings/threats/incident',
    community: '/settings/threats/intelligence',
    accountTakeover: '/settings/threats/account-takeover',
    impersonation: '/settings/threats/protection',
    customization: '/settings/threats/customization',
    customizationO365: '/settings/threats/customization/o365',
    allowlist: '/settings/threats/allowlist',
    simulator: '/settings/simulator',
    psima: '/settings/simulator/psima',
    ignoreIpRange: '/settings/ignore-ip-range',
    emailServer: '/settings/integrations/email-server',
    malware: '/settings/integrations/malware',
    alerts: '/settings/integrations/alerts',
    alertsV2: '/settings/integrations/alerts-v2',
    microsoftQuarantine: '/settings/integrations/microsoft-integration',
    deepfakeIntegration: '/settings/integrations/deepfake',
    collaborationApps: '/settings/notifications/collaboration-apps',
    systemAlerts: '/settings/notifications/system',
    endUserAlerts: '/settings/notifications/enduser',
    disclaimers: '/settings/disclaimers',
    partner: '/settings/partner',
    deepFakeGeneral: '/settings/deepfake/general',
    emailIntegration: '/settings/email-encryption/integration',
    emailSettings: '/settings/email-encryption/settings',
    emailCompanyPolicies: '/settings/email-encryption/company-policies',
    creditsSettings: '/settings/account/credits',
    creditsOverview: '/settings/account/credits/overview',
    creditsHistory: '/settings/account/credits/history',
    creditsBilling: '/settings/account/credits/billing',
    emailBranding: '/settings/email-encryption/branding',
  },
  groupSettings: {
    self: '/group-settings',
    wizard: '/group-settings/wizard',
    assign: '/group-settings/assign',
  },
  login: {
    signin: '/signin',
    signout: '/signout',
    resetToken: '/signin/reset/token/',
    resetPassword: '/signin/reset/password/',
  },
  partners: { self: '/partners' },
  mspPortal: { self: '/msp/' },
  activities: { self: '/activities' },
  resources: { self: '/resources' },
  kpi: { self: '/kpi' },
  investigation: {
    threatLog: '/threat-activity',
    ato: '/threat-activity/account-investigation',
  },
  staticDemo: { self: '/sales-demo/create-static' },
  restrictedAccess: { self: '/restricted-access' },
  redTeam: { self: '/red-team' },
  vendorBase: { self: '/vendor-base', legacy: '/vendor-protection' },
  emailEncryption: {
    self: '/email-encryption',
    emailTracking: '/email-encryption/tracking',
    policies: '/email-encryption/policies',
    blockedQuarantined: '/email-encryption/blocked-quarantined',
    clientDashboard: '/email-encryption/client-dashboard',
    mspOverview: '/email-encryption/msp-overview',
  },
  agents: {
    socDashboard: '/agents/soc-dashboard',
  },
}
